export const lightTheme = {
  background: '#eef2ff',
  color: '#0f172a',
  accentColor: '#2563eb',
  accentStrong: '#1d4ed8',
  textSoft: '#475569',
  surface: 'rgba(255, 255, 255, 0.74)',
  surfaceStrong: '#ffffff',
  surfaceMuted: '#f8fafc',
  navSurface: 'rgba(255, 255, 255, 0.78)',
  panelBorder: 'rgba(15, 23, 42, 0.08)',
  shadowColor: 'rgba(15, 23, 42, 0.12)',
  chronoTheme: {
    cardBgColor: 'rgba(255, 255, 255, 0.92)',
    cardForeColor: '#0f172a',
    titleColor: '#0f172a',
  },
  timelineLineColor: 'rgba(148, 163, 184, 0.3)',
  cardBackground: 'rgba(255, 255, 255, 0.86)',
  cardFooterBackground: 'rgba(248, 250, 252, 0.92)',
  cardBorderColor: 'rgba(15, 23, 42, 0.08)',
  bsPrimaryVariant: 'light',
  bsSecondaryVariant: 'dark',
  socialIconBgColor: '#0f172a',
};

export const darkTheme = {
  background: '#030712',
  color: '#e5eefb',
  accentColor: '#60a5fa',
  accentStrong: '#93c5fd',
  textSoft: '#94a3b8',
  surface: 'rgba(15, 23, 42, 0.72)',
  surfaceStrong: '#111827',
  surfaceMuted: '#0f172a',
  navSurface: 'rgba(15, 23, 42, 0.78)',
  panelBorder: 'rgba(148, 163, 184, 0.18)',
  shadowColor: 'rgba(2, 6, 23, 0.45)',
  chronoTheme: {
    cardBgColor: 'rgba(15, 23, 42, 0.92)',
    cardForeColor: '#e5eefb',
    titleColor: '#e5eefb',
  },
  timelineLineColor: 'rgba(148, 163, 184, 0.28)',
  cardBackground: 'rgba(15, 23, 42, 0.84)',
  cardFooterBackground: 'rgba(15, 23, 42, 0.95)',
  cardBorderColor: 'rgba(148, 163, 184, 0.18)',
  bsPrimaryVariant: 'dark',
  bsSecondaryVariant: 'light',
  socialIconBgColor: '#fefefe',
};
